// extracted by mini-css-extract-plugin
export default {"alertMsgContainer":"Alert_alertMsgContainer__79QQa","alertMsg":"Alert_alertMsg__W048g","alertContactSupport":"Alert_alertContactSupport__SxjIh"};